<template>

  <div id="loginbg">  ·
    <div id="ding">
      <div class="title"id="wenzi">
        自提系统
      </div>
      <div class="title"id="zhanghao">
        账号
      </div>
      <div class="title"id="tuichu"@click="logout">
        【退出】
      </div>
      <div class="title"id="yuyue" @click="tiaozhuanyuyue">
        预约
      </div>
    </div>
    <!--<div id="lujing">
    </div>-->

    <el-form label-position="left" label-width="0px" id="products" class="demo-ruleForm">
      <div id="lujingkongzhi">
        <img id="lujing" src="../../assets/lujing.png">
      </div>
      <template >
        <div class="block">
          <span class="demonstration"></span>
          <el-carousel trigger="click" height="300px">
            <el-carousel-item v-for="item in imgList" :key="item.id">
              <img id="product1" :src="item.url" class="image">
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
      <!--<img id="dazhaxie" src="../../assets/dazhaxie.jpg">-->
      <!--<el-form-item prop="name">
        <el-row style="top: 15px">
          名称：{{products[0].name}}
          {{products[1] == null ? '' : dunhao+products[1].name}}
          {{products[2] == null ? '' : dunhao+products[2].name}}
          &lt;!&ndash;{{products[3] == null ? '' : dunhao+products[3].name}}&ndash;&gt;
        </el-row>
      </el-form-item>
      <el-form-item prop="spec">
          <el-row style="top: 8px">
            规格：{{products[0].spec}}
            {{products[1] == null ? '' : dunhao+products[1].spec}}
            {{products[2] == null ? '' : dunhao+products[2].spec}}
            &lt;!&ndash;{{products[3] == null ? '' : dunhao+products[3].spec}}&ndash;&gt;
          </el-row>
      </el-form-item>
      <el-form-item prop="number">
          <el-row>
            数量：{{products[0].number}}
            {{products[1] == null ? '' : dunhao+products[1].number}}
            {{products[2] == null ? '' : dunhao+products[2].number}}
            &lt;!&ndash;{{products[3] == null ? '' : dunhao+products[3].number}}&ndash;&gt;
          </el-row>
      </el-form-item>-->
      <el-form-item style="width:100%;">
      </el-form-item>
      <el-form-item style="width:100%;">
      </el-form-item>
      <el-form-item style="width:100%;">
      </el-form-item>
      <el-form-item style="width:100%;">
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary"  style="width:100%;" @click="goReservationOrder" >下一步</el-button>
      </el-form-item>
    </el-form>
    <!--<el-table @row-click="rowClick" :data="courses" v-loading="listLoading"  @selection-change="selsChange"
              highlight-current-row  style="width: 100%;">
      <img id="lujing" src="../../assets/lujing.png">
      <el-table-column prop="logo" label="图标" min-width="180" sortable>
        <template slot-scope="scope">
          <img :src="'http://47.95.117.210:8888' + scope.row.logo" min-width="70" height="70"/>

        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" >
      </el-table-column>
      <el-table-column prop="spec" label="规格" >
      </el-table-column>
      <el-table-column prop="number" label="数量" >
      </el-table-column>
    </el-table>-->
  </div>
</template>

<script>
  import { requestLogin } from '../../api/api';
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        imgList:[{
          id:null,
          url:""
        }],
        dunhao:'、',
        name:[],
        spec:[],
        number : [],
        url : [],
        products:[
          {
            name : '',
            spec : '',
            number : '',
            url : ''
          }
        ],
        logining: false,
        checked: false
      };
    },
    methods: {
      goReservationOrder(ev) {
        this.card = this.$route.query.card;
        var card2 = this.card;
        this.$router.push({ path: '/reservationOrder',query: {card:card2} });
      },
      selectProduct(){
        this.card = this.$route.query.card;
        let para = {card : this.card}
        this.$http.post("/order/selectProduct",para).then(res=>{
          if(res.data.success){
            this.products = JSON.parse(JSON.stringify(res.data.data));
            for (var i = 0;i<this.products.length;i++){
              this.products.name = this.products[i].name
              this.products.spec = this.products[i].spec
              this.products.number = this.products[i].number
              /*this.products.url = this.products[i].url*/
            }
          }else{
            this.$message.error(res.data.message);
          }
        })
      },
      selectUrl(){
        this.card = this.$route.query.card;
        let para = {card : this.card}
        this.$http.post("/order/selectUrl",para).then(res=>{
          if(res.data.success){
            this.imgList = res.data.data
          }else{
            this.$message.error(res.data.message);
          }
        })
      },
      //退出
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          //====================退出的时候需要刷新一下本地的路由缓存
          //location.reload();
          //================
          this.$router.push({ path: '/login' });
        }).catch(() => {
        });
      },
      tiaozhuanyuyue(){
        this.card = this.$route.query.card;
        var card2 = this.card;
        this.$router.push({ path: '/reservationOrder',query: {card:card2} });
      },
    },
    mounted() {
      this.selectProduct();
      this.selectUrl();
    }
  }

</script>

<style lang="scss" scoped>
  #products{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 7px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;background-repeat: no-repeat;
    height: 100%;
    //background-color: black;
  }
  #ding{
    background-color: #303133;
    height: 58px;
    margin-top: -18px;
  }
  #wenzi{
    position: absolute;
    margin-top: 18px;
    font-size: large;
    color: white;
    left: 100px;
    font-family: "PingFang SC";
    font-weight: 600;
  }
  #zhanghao{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 230px;
    font-family: "PingFang SC";
    font-weight: 400;
  }
  #tuichu{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 400px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #tuichu:hover {
    color: #c1e9f8;
  }
  #yuyue{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 320px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #yuyue:hover {
    color: #c1e9f8;
  }
  #lujing{
    //position: absolute;
    height: 40px;
    margin-left: 60px;
    margin-top: -50px;
  }
  #lujingkongzhi{
    //position: absolute;
    height: 40px;
    top: 138px;
  }
  #dazhaxie{
    width: 200px;
    margin-left: 70px;
  }
  #product1{
    width: 200px;
    margin-left: 70px;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// CardProduct.vue?c1dab8a4